import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme } from '@mui/material';
import { MainLayout } from './components/layout/MainLayout';
import { themeOptions } from './config/theme.config';
import { Navbar } from './components/navigation/Navbar';
import { navigationConfig } from './config/navigation.config';
import { AppRoutes } from './components/routing/AppRoutes';

const theme = createTheme(themeOptions);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <MainLayout>
          <Navbar title="Sebastian Oes" items={navigationConfig} />
          <AppRoutes />
        </MainLayout>
      </BrowserRouter>
    </ThemeProvider>
  );
}
